export enum DurationType {
	DURATION_IN_DAY = "DURATION_IN_DAY",
	DURATION_OVER_DAY = "DURATION_OVER_DAY",
}
